
.qumra-quantity-container{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  font-size: 1rem;
}
.qumra-quantity-input{
  box-sizing: border-box;
  text-align: center;
  background-color:#F3F3F3 ;
  border: 1px solid #E9E9E9;
  border-radius: var(--mainRadius);
  height: 32px ;
  width: 32px ;
  cursor: pointer;
}
.qumra-quantity-input-button{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:transparent ;
  border: 1px solid #E9E9E9;
  border-radius: var(--mainRadius);
  cursor: pointer;

}
.qumra-quantity-input-button:hover{
  background-color: #e5e7eb;
}
.qumra-quantity-input-button:focus,.qumra-quantity-input:focus {
  outline: none;
   border: 1.5px solid rgb(209 213 219);
}
.qumra-w-6 {
  width: 24px 
}
.qumra-h-6 {
  height:24px 
}
@media (min-width: 992px) {
  .qumra-lg\:h-10 {
      height: 40px 
  }
  .qumra-lg\:w-10 {
    width: 40px 
}
}
